import { sendGenericEmail } from "../../api";
import { parsePreference } from "../../utils";
import { AnalyticsIcon, FolderClockIcon, FolderInputIcon, FolderOutputIcon, FolderSearchIcon, FolderXIcon } from "./Components/Icons/icons";

export const getCoissancePageTabs = ({preferences, accessibleOnly = false}) => {
  return [
    {
      id: "CLIENTS_PROSPECT",
      key: "CLIENTS_PROSPECT",
      label: "Clients Prospects",
      subTitle: "clientsProspects",
      icon: <FolderClockIcon size={18} />,
      hasAccess: true,
      // hasAccess: parsePreference(preferences.financial).croissance.allowAccessIN,
    },
    {
      id: "CLIENTS_IN",
      key: "CLIENTS_IN",
      label: "Clients Entrants",
      subTitle: "clientsEntrants",
      icon: <FolderInputIcon size={18} />,
      hasAccess: parsePreference(preferences.financial).croissance.allowAccessIN,
    },
    {
      id: "CLIENTS_TO_MONITOR",
      key: "CLIENTS_TO_MONITOR",
      label: "Clients à suivre",
      subTitle: "clientsToMonitor",
      icon: <FolderSearchIcon size={18} />,
      hasAccess: parsePreference(preferences.financial).croissance.allowAccessToMonitor,
    },
    {
      id: "LEAVING_CLIENTS",
      key: "LEAVING_CLIENTS",
      label: "Clients en partance",
      subTitle: "leavingClients",
      icon: <FolderXIcon size={18} />,
      hasAccess: parsePreference(preferences.financial).croissance.allowAccessLeaving,
    },
    {
      id: "CLIENTS_OUT",
      key: "CLIENTS_OUT",
      label: "Clients Sortants",
      subTitle: "clientsSortants",
      icon: <FolderOutputIcon size={18} />,
      hasAccess: parsePreference(preferences.financial).croissance.allowAccessOUT,
    },
    {
      id: "REVIEW",
      key: "REVIEW",
      label: "Review",
      subTitle: "clientsReview",
      icon: <AnalyticsIcon size={18} />,
      hasAccess: parsePreference(preferences.financial).croissance.allowAccessReview,
    },
  ].filter(tab => accessibleOnly ? tab.hasAccess : true);
}

export const sendMailToFollowupClient = async ({
  token,
  language,
  user,
  client,
  meetingDate,
  partner,
  organization,
  clientStatus
}) => {
  const recipients = {};
  const dynamicFields = {};

  try {
    recipients[user.id ?? "470189"] = client.email ?? "";
    dynamicFields["{{CLIENT_NAME}}"] = client?.name;
    dynamicFields["{{MEETING_DATE}}"] = meetingDate;
    dynamicFields["{{PARTNER_NAME}}"] = partner?.name;
    dynamicFields["{{ORGANIZATION_NAME}}"] = organization?.name;
    dynamicFields["{{PARTNER_EMAIL}}"] = partner?.email;
    // dynamicFields["{{PARTNER_PHONE}}"] = "";
  } catch (error) {
    return null;
  }

  let type = "POWERTEAM_RISKY_CLIENT_EMAIL";

  if (clientStatus === 'RECOVERED') {
    type = "POWERTEAM_RECOVERED_CLIENT_EMAIL";
  } else if (clientStatus === 'LEAVING') {
    type = "POWERTEAM_LEAVING_CLIENT_EMAIL";
  }

  return await sendGenericEmail(
    token,
    recipients,
    type,
    language,
    dynamicFields,
    organization.id
  );
}

export const sendMailToRecoveredClient = async ({
  token,
  language,
  user,
  client,
  meetingDate,
  partner,
  organization
}) => {
  const recipients = {};
  const dynamicFields = {};

  try {
    recipients[user.id ?? "470189"] = client.email ?? "";
    dynamicFields["{{CLIENT_NAME}}"] = client.name;
    dynamicFields["{{MEETING_DATE}}"] = meetingDate;
    dynamicFields["{{PARTNER_NAME}}"] = partner.name;
    dynamicFields["{{ORGANIZATION_NAME}}"] = organization.name;
    dynamicFields["{{PARTNER_EMAIL}}"] = partner.email;
    // dynamicFields["{{PARTNER_PHONE}}"] = "";
  } catch (error) {
    return null;
  }

  return await sendGenericEmail(
    token,
    recipients,
    "POWERTEAM_RECOVERED_CLIENT_EMAIL",
    language,
    dynamicFields,
    organization.id
  );
}

export const isMailSentToClientWithStatus = (status, emailNotificationsSend) => {
  if (!status || !emailNotificationsSend) return false;

  switch (status) {
    case "RISKY": return emailNotificationsSend?.asRisky?.isSent === 1;
    case "LEAVING": return emailNotificationsSend?.asLeaving?.isSent === 1;
    case "RECOVERED": return emailNotificationsSend?.asRecovered?.isSent === 1;
    default: return false;
  }
}
